'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaExtraServicesBookedController = function () {
  function WinresOmalomaExtraServicesBookedController($rootScope, $scope, omalomaService, $q, reservationService) {
    _classCallCheck(this, WinresOmalomaExtraServicesBookedController);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.omalomaService = omalomaService;
    this.$q = $q;
    this.reservationService = reservationService;

    this.$scope._ = _;

    this.clear();

    // Use a set status function and ngSwitch to control front en status when booking extra services
    // For example show a message  when booking is pending
    this.setStatus('init', null);
  }

  _createClass(WinresOmalomaExtraServicesBookedController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$rootScope.$on('login', function () {
        return _this.load();
      });
      this.$rootScope.$on('logout', function () {
        return _this.clear();
      });
      if (this.omalomaService.isLoggedInAsCustomer()) {
        this.load();
      } else {
        this.setStatus('out', null);
      }
      this.$scope.$watch(function () {
        return _this.bookingNumber;
      }, function () {
        return _this.load();
      });

      this.$rootScope.$on('omaloma-refresh', function () {
        return _this.refresh();
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.clear();
      if (!this.bookingNumber || !this.omalomaService.isLoggedInAsCustomer()) return;
      this.load();
    }

    // Initialize / disable the component, due to e.g. user logout.

  }, {
    key: 'clear',
    value: function clear() {
      this.$scope.bookedExtraServices = null;
      this.$scope.passengers = null;
      this.$scope.reservable = null;
      this.$scope.productLines = null;
      this.$scope.loading = false;
      this.$scope.error = null;
      this.setStatus('out', null);

      // A map of product data for relevant products. Relevant products are:
      // - Previously reserved products
      // - Reservable products
      // The map is organized by destination code and product code.
      // this.$scope.relevantProducts = null;
    }
  }, {
    key: 'load',
    value: function load() {
      this.setStatus('waiting', null);
      this.getBookedLines();
    }
  }, {
    key: 'getBookedLines',
    value: function getBookedLines() {
      var _this2 = this;

      this.clear();
      if (!this.bookingNumber) return;
      this.setStatus('waiting', null);
      this.omalomaService.getBookedExtraServices(this.bookingNumber).then(function (result) {
        console.log('[WOESB] Received Booked  extra services.', result);

        var resultLink = _.filter(result, function (r) {
          return r.LinkingInfo;
        });
        var resultNoLink = _.filter(result, function (r) {
          return !r.LinkingInfo;
        });

        _this2.bookedLines = resultLink.concat(resultNoLink);

        _this2.getPassengers();
      }, function (error) {
        console.error('[WOESB] Failed to receive Booked  extra services.', error);
        _this2.clear();
        _this2.setStatus('error', error);
      });
    }
  }, {
    key: 'getPassengers',
    value: function getPassengers() {
      var _this3 = this;

      if (!this.bookingNumber) return;
      this.setStatus('waiting', null);
      this.omalomaService.getPassengers(this.bookingNumber).then(function (result) {
        console.log("[WOESB] Got passengers, result: ", result);
        _this3.passengers = result;

        _this3.getExtraServices();
      }, function (error) {
        console.error("[WOESB] Failed to get passengers ", error);
        _this3.setStatus('error', error);
      });
    }

    // Get extra services to get the Lookups.RelevantProducts so that we can get product human readable names etc..

  }, {
    key: 'getExtraServices',
    value: function getExtraServices() {
      var _this4 = this;

      this.clear();
      if (!this.bookingNumber) return;
      this.setStatus('waiting', null);
      this.omalomaService.getCustomerReservableExtraServices(this.bookingNumber).then(function (result) {
        console.log('[WOESB] Received extra services.', result);
        _this4.relevantProducts = result.Lookups.RelevantProducts;
        console.log('[WOESB] RelevantProducts', _this4.relevantProducts);

        _this4.update();
      }, function (error) {
        console.error('[WOESB] Failed to receive extra services.', error);
        _this4.clear();
        _this4.$scope.error = 'malfunction';
        _this4.setStatus('error', null);
      });
    }
  }, {
    key: 'update',
    value: function update() {
      var _this5 = this;

      if (!this.bookedLines) {
        console.log('[WOESB] No product lines yet. Cannot update.');
        return;
      } else if (!this.passengers) {
        console.log('[WOESB] No passengers yet. Cannot update.');
        return;
      }
      console.log("[WOESB] doing the lines...");
      var rows = _.map(this.bookedLines, function (line) {
        var product = _this5.relevantProducts[line.DestinationCode][line.ProductCode];
        console.log("[WOESB] product: ", product);
        console.log("[WOESB] line: ", line);

        // get passenger names and simply list them
        var passengersList = [];
        for (var item = 0; item < line.Passengers.length; item++) {
          if (line.Passengers[item] === true) {
            console.log("[WOESB] Got Passenger " + item + ' ', line.Passengers, " for product" + product.DestinationInfo.ProductName);
            var passengerEntry = _this5.passengers[item].FirstName + ' ' + _this5.passengers[item].LastName;
            passengersList.push(passengerEntry);
            console.log("[WOESB] added passenger entry: " + passengerEntry + " to passengerList: ", passengersList);
          }
        }

        var serviceImage = (0, _utils.findImage)(product);

        _this5.setStatus('ready', null);

        return {
          amount: line.Capacity,
          name: product.DestinationInfo.ProductName,
          beginDate: line.BeginDate ? moment(line.BeginDate).format('YYYY-MM-DD') : null,
          endDate: line.EndDate ? moment(line.EndDate).format('YYYY-MM-DD') : null,
          price: !product.HidePrice ? line.Price : null,
          assignedPassengers: passengersList,
          image: serviceImage,
          linkingInfo: line.LinkingInfo
        };
      });

      this.$scope.rows = rows;
    }
  }, {
    key: 'setStatus',
    value: function setStatus(status, error) {
      this.$scope.status = status;
      console.log('Extra services status set  to', status);
      if (error !== undefined) {
        if (error) {
          console.error('Extra services status ERROR: ', error);
          this.$scope.error = error;
        }
      }
    }
  }, {
    key: 'goToExtraServicesTab',
    value: function goToExtraServicesTab() {

      var tabID = angular.element('winres-omaloma-extra-services').closest('.tab-content').attr('id');
      console.log("[WOESB] Going to extra services: TabID: ", tabID);
      document.querySelectorAll('a[href="#' + tabID + '"]')[0].click();
      console.log("[WOESB] Went to extra services!");
    }
  }]);

  return WinresOmalomaExtraServicesBookedController;
}();

WinresOmalomaExtraServicesBookedController.$inject = ['$rootScope', '$scope', 'omalomaService', '$q', 'reservationService'];

_module3.default.component('winresOmalomaExtraServicesBooked', {
  template: require('./winresOmalomaExtraServicesBooked.html'),
  controller: WinresOmalomaExtraServicesBookedController,
  require: {},
  bindings: {
    bookingNumber: '<',
    onChange: '&',
    onPassengersChange: '&' // NOTE: Passengers should probably be fetched somewhere else later
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaExtraServicesBooked/winresOmalomaExtraServicesBooked.js
// module id = 341
// module chunks = 2